import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { AnyAction } from 'redux';
import { App, JhpVorbelegungdaten, SpecialInfo, TaasInfo } from '@ps20-frontend/frontend-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const jhpTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
): TaasInfo {
  if (action.type === GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED) {
    const actionPayload: JhpVorbelegungdaten = action.payload;
    if (actionPayload.forApp === App.JHP) {
      sectionState.specialInfo = {
        zuschlman: actionPayload.manuellerZuschlag,
        nachlman: actionPayload.manuellerNachlass,
        erhrisiko: actionPayload.erhRisiko,
        aktionsnachlass: actionPayload.aktionsNachlass,
      } as SpecialInfo;
    }
  }
  return taasInfoReducer(sectionState, action, App.JHP);
};
